import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBTextField, DBCheckBox } from '_components';
import styles from '../../../Note/AL/Common.module.css';

class AlWpTestRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLWORKPROG', 'XLWP', this.props.wp.XLWPNO);
    }

    handlePerformed(val) {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.wp.XLWPPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.cell_wrapper}>
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                        </div>
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLWORKPROG'
                            entityKeyColumn='XLWPNO'
                            entityKeyValue={this.props.wp.XLWPNO}
                            field='XLWPACTIVITY'
                            className={this.props.wp.XLWPPERFORMED && !this.props.wp.XLWPACTIVITY ? styles.col2_performed_wp : styles.col2_wp}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLWORKPROG'
                            entityKeyColumn='XLWPNO'
                            entityKeyValue={this.props.wp.XLWPNO}
                            field='XLWPSETSREPS'
                            className={styles.col3}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLWORKPROG'
                            entityKeyColumn='XLWPNO'
                            entityKeyValue={this.props.wp.XLWPNO}
                            field='XLWPPERFORMED'
                            className={styles.col4_wp}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <span className={styles.col5} />
                    </div>
                </div>
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let wp = state.entities.notes.MLWORKPROG[ownprops.id];

    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let onAssessment = state.entities.notes.PTPLAN[plno] && state.entities.notes.PTPLAN[plno].PLSPEECH ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        wp,
        onAssessment,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlWpTestRow = connect(mapStateToProps, mapDispatchToProps)(AlWpTestRow);
export { connectedAlWpTestRow as AlWpTestRow };

